<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Instalações</h4>
          </div>
          <div class="col-md-12">
            <div class="col-md-6">
              <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile  btn-primary" @click="carregaDesk">Desktop</button>
              <!-- <button class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile  btn-primary" @click="carregaApp">App</button> -->
            </div>
          </div>
          <table class="table table-striped" v-if="desktop">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>CNPJ</th> 
                <th class="text-center">API</th> 
                <th class="text-center">Versão</th> 
                <th class="text-right">Última Sinc.</th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instalacao of instalacoes">
                <td>{{ instalacao.apelido }} ({{ instalacao.idi }})</td>
                <td>{{ instalacao.cnpj }}</td>
                <td class="text-center">{{ instalacao.versao_sistema }}</td>
                <td class="text-center">{{ instalacao.version }}</td>
                <td class="text-right">{{ instalacao.ultima_conexao_ws | moment('DD/MM/YYYY HH:mm')}}</td>
                <td class="text-right">
                  <div v-if="instalacao.status_nota" class="status" v-bind:class="[instalacao.status_nota]"></div>
                  <div class="status" v-bind:class="[instalacao.status]"></div>
                </td>
              </tr>
              <tr v-if="!instalacoes || !instalacoes.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-striped" v-if="app">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>CNPJ</th> 
                <th class="text-right">Última Sinc.</th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instalacao_app of instalacoes_app">
                <td>{{ instalacao_app.apelido }} ({{ instalacao_app.idi }})</td>
                <td>{{ instalacao_app.cnpj }}</td>
                <td class="text-right">{{ instalacao_app.data_venda | moment('DD/MM/YYYY HH:mm')}}</td>
                <td class="text-right">
                  <div v-if="instalacao_app.status_nota" class="status" v-bind:class="[instalacao_app.status_nota]"></div>
                  <div class="status" v-bind:class="[instalacao_app.status]"></div>
                </td>
              </tr>
              <tr v-if="!instalacoes_app || !instalacoes_app.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col-12">
              Mostrando {{ total }} registros
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import InstalacaoService from '@/services/InstalacaoService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        instalacoes: [],
        instalacoes_app: [],
        total: 0,
        desktop:true,
        app:false,
        current_page: 1,
      }
    },
    methods:{
      carregaDesk(page) {
        this.app = false;
        this.desktop = true;
        
        InstalacaoService.load(`?page=${this.current_page}`).then(res => {
          this.instalacoes = res.data.data
          this.total = res.data.total;
        }).catch(err => {
          console.error(err)
        })
      },
      carregaApp(page) {
        this.desktop = false;
        this.app = true;

        InstalacaoService.loadApp().then(res => {
          this.instalacoes_app = res.data
          this.total = res.data.length
        }).catch(err => {
          console.error(err)
        })
      },
    },
    mounted() {
      this.carregaDesk()
    }
}
</script>

<style>
  .status {
    display: inline-block; margin-right: 6px;
  }
  .status.danger {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.alive {
    background-color: #26de81;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.warning {
    background-color: #fed330;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
</style>